/** @jsxImportSource @emotion/react */
import React, { useCallback, useMemo } from 'react'
import { SwapOutlined } from '@ant-design/icons'
import {
  HomeTeam,
  VisitingTeam,
} from '@sportninja/common/types/PlayerAttendance'
import {
  roleButtonColumnStyle,
  roleButtonLabelAboveStyle,
  roleButtonContainerStyle,
  roleButtonNameStyle,
  roleButtonSwapIconStyle,
} from '../styles'
import { trackEvent, getPlatformType } from '../../../utils/analytics'
import { ROLE_ASSIGNMENT_TEXT } from '@sportninja/common/features/social/components/GameWidget/constants'
export interface VideographerInfoProps {
  isTeamRepOnTeam: boolean
  team: HomeTeam | VisitingTeam
  onPressManageVideographer: (
    gameId: string,
    rosterId: string,
    teamId: string,
    teamName: string,
    teamSide: 'home' | 'visitor'
  ) => void
  gameId: string
  showVideo: boolean
  teamSide: 'home' | 'visitor'
}

const VideographerInfo: React.FC<VideographerInfoProps> = ({
  isTeamRepOnTeam,
  team,
  onPressManageVideographer,
  gameId,
  showVideo,
  teamSide,
}) => {
  const handleClick = useCallback(() => {
    if (!isTeamRepOnTeam) {
      return
    }
    trackEvent('home_game_card_videographer_tapped', {
      platform: getPlatformType(),
      game_id: gameId,
      team_side: teamSide,
      has_assignment: !!team?.videographer_user,
    })
    onPressManageVideographer(
      gameId,
      team?.game_roster_id,
      team?.id,
      team?.name,
      teamSide
    )
  }, [isTeamRepOnTeam, onPressManageVideographer, gameId, team, teamSide])

  const displayText = useMemo(() => {
    const videographer = team?.videographer_user
    if (!videographer) {
      return isTeamRepOnTeam
        ? ROLE_ASSIGNMENT_TEXT.TEAM_REP
        : ROLE_ASSIGNMENT_TEXT.NOT_SET
    }
    return (
      videographer.name_full ||
      `${videographer.name_first} ${videographer.name_last}`.trim()
    )
  }, [team?.videographer_user, isTeamRepOnTeam])

  // Avatar image source — kept for potential re-introduction of the avatar display.
  // const imageSrc = useMemo(() => {
  //   const videographer = team?.videographer_user
  //   if (!videographer) {
  //     return PLACEHOLDER_PLAYER
  //   }
  //   return getImageThumbnailId(videographer) || PLACEHOLDER_PLAYER
  // }, [team?.videographer_user])

  if (!showVideo) {
    return null
  }

  return (
    <div css={roleButtonColumnStyle}>
      <p css={roleButtonLabelAboveStyle}>Videographer</p>
      <div
        css={roleButtonContainerStyle(isTeamRepOnTeam)}
        onClick={handleClick}
      >
        <p css={roleButtonNameStyle}>{displayText}</p>
        {isTeamRepOnTeam ? (
          <SwapOutlined css={roleButtonSwapIconStyle} />
        ) : null}
      </div>
    </div>
  )
}

export default React.memo(VideographerInfo)
